import CountUp from "react-countup";
import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

function DefaultCounterCard({ color = "info", count, title, description, ...rest }) {
  // Only animate CountUp when in viewport — prevents reflow during initial paint
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true);
          obs.disconnect();
        }
      },
      { rootMargin: "0px", threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [inView]);

  return (
    <Box ref={ref} p={2} textAlign="center" lineHeight={1.25}>
      <Typography variant="h1" component="div" color={`${color}.main`} sx={{ fontWeight: "bold" }}>
        {inView ? <CountUp end={count} duration={1} {...rest} /> : `0${rest.suffix || ""}`}
      </Typography>
      {title && (
        <Typography variant="h5" component="h4" mt={2} mb={1}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
}

DefaultCounterCard.propTypes = {
  color: PropTypes.string,
  count: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.node,
};

export default DefaultCounterCard;
